import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";

const BrokerLoginError = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const errorMessage = location.state?.message || "Authentication failed. Please try again.";
  const errorCode = location.state?.code || "UNKNOWN_ERROR";

  const getErrorTitle = () => {
    switch (errorCode) {
      case "USER_NOT_ASSIGNED":
        return "Unauthorized access";
      case "INVALID_TOKEN":
        return "Invalid session";
      case "NETWORK_ERROR":
        return "Connection error";
      default:
        return "Authentication error";
    }
  };

  const getErrorDescription = () => {
    switch (errorCode) {
      case "USER_NOT_ASSIGNED":
        return "Your account is not authorized to access this application. Please contact your system administrator.";
      case "INVALID_TOKEN":
        return "Your session has expired or is invalid. Please sign in again.";
      case "NETWORK_ERROR":
        return "Unable to connect to the authentication server. Check your internet connection and try again.";
      case "BACKEND_ERROR":
        return "An error occurred while processing your request. Please try again later.";
      default:
        return errorMessage || "An unexpected error occurred during sign-in. Please try again.";
    }
  };

  const handleRetry = () => {
    navigate("/login", { replace: true });
  };

  const handleGoHome = () => {
    navigate("/login", { replace: true });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#EEF2F7",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "450px",
          backgroundColor: "#ffffff",
          borderRadius: "4px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            backgroundColor: "#192853",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <img
            src={"/Logo_white.svg"}
            alt={"PrestigePEO logo"}
            style={{ height: 45 }}
          />
        </div>

        <div style={{ padding: "40px 30px" }}>
          <div
            style={{
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                margin: "0 auto 15px",
                backgroundColor: "#fff3cd",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "30px",
              }}
            >
              ⚠️
            </div>
            <h2
              style={{
                margin: "0 0 15px 0",
                color: "#192853",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              {getErrorTitle()}
            </h2>
            <p
              style={{
                margin: "0 0 20px 0",
                color: "#666",
                fontSize: "14px",
                lineHeight: "1.6",
              }}
            >
              {getErrorDescription()}
            </p>
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <Button
              themeColor="primary"
              onClick={handleRetry}
              style={{ minWidth: "140px" }}
            >
              Try again
            </Button>
            <Button
              themeColor="info"
              fillMode="outline"
              onClick={handleGoHome}
              style={{ minWidth: "140px" }}
            >
              Back to sign-in
            </Button>
          </div>

          <div
            style={{
              marginTop: "30px",
              paddingTop: "20px",
              borderTop: "1px solid #eee",
              fontSize: "12px",
              color: "#999",
              textAlign: "center",
            }}
          >
            <p style={{ margin: "0 0 5px 0" }}>Error code: {errorCode}</p>
            <p style={{ margin: "0" }}>
              If the problem persists, contact technical support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrokerLoginError;
